module.exports = __webpack_public_path__ + "img/hand-spock.ddcb87e6.svg";